import "@/App.css";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Messenger from "./pages/Messenger";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import Search from "./pages/Search";
import Chats from "./pages/Chats";
import Chat from "./pages/Chat";
import Channels from "./pages/Channels";
import CreateChannel from "./pages/CreateChannel";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/register" replace />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<Navigate to="/login" replace />} />
      <Route path="/messenger" element={<Messenger />} />
      <Route path="/MiraLink" element={<Navigate to="/messenger" replace />} />
      <Route path="/profile/:username" element={<Profile />} />
      <Route path="/MiraLink/:username" element={<Profile />} />
      <Route path="/@:username" element={<Profile />} />
      <Route path="/edit-profile" element={<EditProfile />} />
      <Route path="/search" element={<Search />} />
      <Route path="/chats" element={<Chats />} />
      <Route path="/chat/:id" element={<Chat />} />
      <Route path="/channels" element={<Channels />} />
      <Route path="/channels/create" element={<CreateChannel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HashRouter>
        <AppRouter />
      </HashRouter>
    </div>
  );
}

export default App;







